import { render, staticRenderFns } from "./OffersParticipantGroupSubTableDetails.vue?vue&type=template&id=773aebaf&scoped=true"
import script from "./OffersParticipantGroupSubTableDetails.vue?vue&type=script&lang=js"
export * from "./OffersParticipantGroupSubTableDetails.vue?vue&type=script&lang=js"
import style0 from "./OffersParticipantGroupSubTableDetails.vue?vue&type=style&index=0&id=773aebaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773aebaf",
  null
  
)

export default component.exports